<template>
    <v-container>
        <v-skeleton-loader
            v-if="!histories"
            type="list-item-avatar-three-line@3"
        ></v-skeleton-loader>
        <div
            v-else-if="histories.length === 0"
            class="text-center mt-4"
        >
            Kamu belum pernah mengerjakan tryout. Kamu bisa mengerjakan tryout
            di halaman
            <router-link :to="{ name: 'tryout' }">Tryout</router-link>
            .
        </div>
        <v-list v-else>
            <v-list-item
                v-for="history in histories"
                :key="history.hash"
                three-line
                link
                @click="showHistory(history)"
            >
                <v-list-item-avatar color="primary">
                    <v-icon color="white">mdi-file-check-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>
                        {{ history.tryout_title }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        Selesai pada {{ history.finished_at }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                        Dengan nilai {{ history.grade }}
                    </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
import { parseFromServer } from '@/plugins/moment'

export default {
    data() {
        return {
            histories: null,
        }
    },

    methods: {
        showHistory(history) {
            this.$router.push({
                name: 'grade.detail',
                params: { history_hash: history.hash },
            })
        },
    },

    created() {
        this.$api.get('history').then((response) => {
            this.histories = response.data.histories.map((e) => {
                return {
                    ...e,
                    finished_at: parseFromServer(
                        e.finished_at
                    ).formatShortDayAndTime(),
                }
            })
        })
    },
}
</script>
